<template>
  <div class="modal fade bd-example-modal-lg" :id="option.id" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title">複製選取設定至其他店家</h4>
        </div>
        <div class="modal-body">
          <!-- /.box-header -->
          <div class="p-b-10">
            <h5><span class="text-pink">＊</span> {{ tooltip }}</h5>
          </div>
          <div v-if="getRoleType !== 10" class="text-left">
            <h5>套用門市</h5>
            <div
              v-for="(storeClass, index) in storeClassList" class="m-r-5 m-b-10 inline-block"
              :key="`storeClass-${index}`"
            >
              <button
                class="btn btn-default"
                :class="{'active': curId === storeClass.id}"
                @click="clickOption(storeClass)"
              >
                {{storeClass.name}}
              </button>
            </div>
          </div>
          <div class="min-h-260">
            <h5 class="text-left">參與店家</h5>
            <!-- 參與店家 -->
            <muti-select-two :setting="addStoresSetting" :reNew="reNew" :reSet="reSet"></muti-select-two>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">
            取消
          </button>
          <button class="btn btn-success" data-dismiss="modal" @click="copyStore">
            確定
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default{
  name: 'chooseStoreModal',
  props: {
    option: {
      type: Object,
      required: true
    },
    tooltip: {
      type: String,
      required: false,
      default: '相同料號的商品會覆蓋設定'
    }
  },
  data () {
    return {
      storeBrief: [],
      addStoresSetting: {
        class: 'copy-store',
        options: [],
        choose: []
      },
      storeClassList: [],
      curId: 0,
      reNew: 0,
      reSet: 0
    }
  },
  methods: {
    getStoreBrief () {
      this.storeBrief = []
      this.addStoresSetting.options = []
      var self = this
      var url = '/brand/' + this.$route.params.brand_id + '/storeListBrief?&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.getStoreClassList()
          var sList = response.data.list
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            if (parseInt(sList[i].store_id, 10) !== parseInt(self.$route.params.store_id, 10)) {
              self.storeBrief.push(obj)
              self.addStoresSetting.options.push(obj)
            }
          }
          self.reNew++
        }
      })
    },
    getStoreClassList () {
      if (this.getRoleType === 10) return

      let url = 'brand/' + this.$route.params.brand_id + '/storeClassList'
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          const sList = response.data.list
          this.storeClassList = sList
        }
      })
    },
    async copyStore () {
      // 回傳店家 ID 陣列
      this.$emit('copyStore', this.addStoresSetting.choose)
    },
    clickOption (option) {
      this.addStoresSetting.options = []
      this.curId = option.id
      if (this.curId) {
        this.$nextTick(() => {
          this.reSet++
          this.addStoresSetting.options = this.storeBrief
          this.getCurStoreClass()
        })
      }
    },
    getCurStoreClass () {
      this.addStoresSetting.choose = []
      let url = 'brand/' + this.$route.params.brand_id + '/storeClass/' + this.curId
      if (this.getRoleType === 10) url = 'store/' + this.$route.params.brand_id + '/storeClass/' + this.curId
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          const classInfo = response.data.class
          classInfo.store_list.forEach((s) => {
            if (s.id !== parseInt(this.$route.params.store_id, 10)) {
              this.addStoresSetting.choose.push(s.id)
            }
          })
        }
      })
    }
  },
  created () {
    this.getStoreBrief()
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    }
  }
}
</script>

<style lang="scss" scoped>
.min-h-260 {
  min-height: 260px;
}
.modal-header {
  border-bottom: 1px solid #e5e5e5;
}
</style>



// WEBPACK FOOTER //
// chooseStoreModal.vue?3a00027c